// @flow
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const LevelBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  max-width: 320px;
  margin: 8px 0 16px;

  > svg:first-child {
    position: relative;
    z-index: 100;
    margin-left: ${({ risk }) =>
    (risk === 1 ? '0' : risk === 7 ? 'calc(100% - 17px)' : `calc((100%/6) * ${risk - 1} - 11px)`)};
  }

  > svg:nth-child(2) {
    position: absolute;
  }

  ${maxMediaQueries.phone`
    max-width: 240px;
    > svg:first-child {
      width: 16px;
      margin-left: ${({ risk }) =>
    (risk === 1 ? '0' : risk === 7 ? 'calc(100% - 17px)' : `calc((100%/6) * ${risk - 1} - 11px)`)};
    }
    > svg:nth-child(2) {
      width: 240px;
    }
  `}
`;

export const PillSummary = styled.iframe`
  max-width: 270px;
  height: 410px;
  border: none;
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows.extraBlack};
  margin: 16px 0;

  #app {
    overflow: hidden;
  }

  ${minMediaQueries.phone`
    min-width: 400px;
  `}
`;

export const Inner = styled.div`
  min-height: 460px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.terciaryL};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: 0 5px 10px rgb(0 0 0 / 0.0973);
  margin-bottom: 72px;

  > a {
    margin-top: 8px;
  }
`;

export const BlockInner = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.terciaryD};

  > span {
    ${getFont(0)}
    font-weight: 700;
  }

  ${maxMediaQueries.miniDesktop`
    flex-flow: column;
    align-items: center;
  `}
`;

export const Block = styled.div`
  width: 100%;

  > span {
    ${getFont(0)}
    font-weight: 700;
  }

  ${minMediaQueries.miniDesktop`
    width: 65%;
    margin-bottom: 12px;
  `}
`;
